export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/edc37492-aad1-484e-85c4-18ddf97f686d.png"
              alt="ChronoCharm"
              className="h-12 w-auto mb-6"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              高級腕時計の世界を、より深く、より正確に。ChronoCharmは、時計愛好家のための信頼できる情報源です。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-medium mb-6">クイックリンク</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-400 hover:text-amber-400 transition-colors text-sm cursor-pointer"
                >
                  私たちについて
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-amber-400 transition-colors text-sm cursor-pointer"
                >
                  取扱ブランド
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('testimonials')}
                  className="text-gray-400 hover:text-amber-400 transition-colors text-sm cursor-pointer"
                >
                  お客様の声
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-400 hover:text-amber-400 transition-colors text-sm cursor-pointer"
                >
                  お問い合わせ
                </button>
              </li>
            </ul>
          </div>

          {/* Brands */}
          <div>
            <h4 className="text-lg font-medium mb-6">人気ブランド</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-400 hover:text-amber-400 transition-colors text-sm cursor-pointer">
                  ロレックス
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-amber-400 transition-colors text-sm cursor-pointer">
                  カルティエ
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-amber-400 transition-colors text-sm cursor-pointer">
                  IWC
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-amber-400 transition-colors text-sm cursor-pointer">
                  チューダー
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-lg font-medium mb-6">ニュースレター</h4>
            <p className="text-gray-400 text-sm mb-4">
              最新情報をお届けします
            </p>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="メールアドレス"
                className="flex-1 px-4 py-2 text-sm bg-gray-800 border border-gray-700 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent text-white placeholder-gray-500"
              />
              <button className="px-4 py-2 bg-amber-600 text-white rounded-lg hover:bg-amber-700 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-send-plane-fill"></i>
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-sm text-gray-400">
              © 2024 ChronoCharm. All rights reserved.
            </div>
            <div className="flex items-center gap-6">
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-amber-400 transition-colors cursor-pointer">
                Powered by Readdy
              </a>
              <a href="#" className="text-sm text-gray-400 hover:text-amber-400 transition-colors cursor-pointer">
                プライバシーポリシー
              </a>
              <a href="#" className="text-sm text-gray-400 hover:text-amber-400 transition-colors cursor-pointer">
                利用規約
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
